import { useEffect } from "react";
import CloudBanner from "../HomePage/Technology/AllBanner/CloudBanner";
import CloudMain from "./TechnologiesCloudPage/CloudMain";
import FooterContact from "../FooterContactPage/FooterContact";
import { Helmet } from "react-helmet-async";

const TechCloud = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Helmet>
        <title>
          Cloud Architecture Without The Guesswork | Quad Theory Ltd
        </title>
        <meta
          name="description"
          content="Quad Theory Ltd designs practical cloud architectures using AWS, Azure, Firebase, and Vercel. Real world cloud setups built to control cost, performance, and long term operational complexity."
        />
      </Helmet>
      <CloudBanner />
      <CloudMain />
      {/* form component yeameen */}
      <FooterContact />
    </div>
  );
};

export default TechCloud;
